import * as CONFIG from './config';


exports.getArchiveList = function (id) {
    // console.log("getArchive==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/archiveMeetings/getArchiveList' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.getArchiveAgendaList = function (id) {
    // console.log("getArchiveList==>", id);
    return new Promise((resolve, reject) => {
        //resolve('{"CommitteeList": [{"id": 10,"name": "Training Archive - 1","status": "active"},{"id": 11,"name": "BAHRAIN NATIONAL INSURANCE BOARD OF DIRECTORS ","status": "active"},{"id": 12,"name": "BAHRAIN NATIONAL LIFE ASSURANCE BOARD OF DIRECTORS ","status": "active"},{"id": 13,"name": "BAHRAIN NATIONAL HOLDING BOARD OF DIRECTORS","status": "active"},{"id": 14,"name": "BNL Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 15,"name": "BNI Executive & Investment Committee (EIC)","status": "active"},{"id": 16,"name": "BNH Executive & Investment Committee (EIC)","status": "active"},{"id": 17,"name": "BNI Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 18,"name": "BNH Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 19,"name": "BNH Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 20,"name": "BNI Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 21,"name": "BNL Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 22,"name": "Alpha Archive Attendee","status": "active"},{"id": 23,"name": "Alpha Archive Committee Adminstrator","status": "active"},{"id": 24,"name": "Training team2","status": "active"},{"id": 25,"name": "chat team","status": "active"},{"id": 26,"name": "test1team","status": "active"},{"id": 27,"name": "Mobile Archive","status": "active"}]}');
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/archiveMeetings/getArcAgendaList' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.deleteArchive = function (id) {
    // console.log("deleteArchive==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGet('/archiveMeetings/delete/'+id)
            .then(function (response) {
                // console.log('deleteArchive succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('deleteArchive err==>',err);
                reject(err);
            });
    });
}

exports.downloadArchiveFile = function (id) {
    // console.log("deleteArchive==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGet('/file/downloadArchivefiles/'+id)
            .then(function (response) {
                // console.log('deleteArchive succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('deleteArchive err==>',err);
                reject(err);
            });
    });
}

exports.deleteArchiveFile = function (id) {
    // console.log("deleteArchive==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGet('/file/downloadArchivefiles/'+id)
            .then(function (response) {
                // console.log('deleteArchive succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('deleteArchive err==>',err);
                reject(err);
            });
    });
}


// WEBPACK FOOTER //
// ./api/archivedetails.js